export default __webpack_public_path__ + "static/media/usps-icon.278936a4.svg";